import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProviders } from '@providers/AppProviders';
import App from './App';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Elemento raiz #root não encontrado no index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
);
